import { GET_STUDENT_SHARE_LINK_LIST } from '../../actions';
import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponse, IShareLink } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type StudentShareLinkListState = ICommonResponse<IShareLink>;

const initialState: StudentShareLinkListState = {
  content: [],
  loading: false,
};
const generic = genericReducers<StudentShareLinkListState>();
const studentShareLinkList: IReducers<StudentShareLinkListState> = {
  [GET_STUDENT_SHARE_LINK_LIST[REQUEST]]: generic.get.request,
  [GET_STUDENT_SHARE_LINK_LIST[SUCCESS]]: generic.get.success,
  [GET_STUDENT_SHARE_LINK_LIST[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, studentShareLinkList);
